const DescriptionList = ({ items }) => {
  return (
    <div>
      <dl className="divide-y divide-ink-100">
        {items?.map(({ label, value }, idx) => (
          <div
            key={idx}
            className="px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0"
          >
            <dt className="text-sm/6 font-medium text-ink-900">{label}</dt>
            <dd className="mt-1 text-sm/6 text-ink-700 sm:col-span-2 sm:mt-0">
              {value || ""}
            </dd>
          </div>
        ))}
      </dl>
    </div>
  );
};

export default DescriptionList;
